<template>
  <v-snackbar v-model="snackbar" color="#05A660ED" rounded="lg" location="top" :width="btnGroupRef?.$el.offsetWidth">
    <v-icon :icon="CheckIcon" size="20"/>
    {{$t('Страница {host}/{link} снята с публикации и больше не отображается пользователям', {link: tapStore?.currentTap?.alias, host: host})}}
  </v-snackbar>
  <div class="profile-footer d-flex ga-2 align-center pl-3 pr-3">
    <v-tooltip
        :model-value="showOnboardingChange"
        max-width="329"
        :open-on-hover="false"
        @close="hintStore.closeHint('change_view')"
        location="top start"
        :offset="[32, 13]">
      <template #default>
        <svg class="tooltip-arrow" style="left: 5px" width="40" height="10" viewBox="0 0 40 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9515 10L22.9604 7.00113C27.459 2.51758 33.5513 -6.96944e-07 39.9026 -1.41695e-07L0.000424306 -3.63006e-06C6.35174 -3.07481e-06 12.4441 2.51757 16.9426 7.00113L19.9515 10Z" fill="#4C5257"/>
        </svg>
        {{ $t('Включён режим просмотра, нажмите тут, чтобы вернуться к редактированию') }}
      </template>
      <template v-slot:activator="{ props: tooltip }">
        <v-hover>
          <template v-slot:default="{ isHovering, props: hover }">
            <teleport to="body" v-if="showOnboarding">
              <div :style="spotlightStyle" class="spotlight">
                <v-icon :icon="tapStore.view ? EyesHideIcon : EyesIcon" v-bind="mergeProps(tooltip, hover)" :color="isHovering ? 'primary' : 'BW-500'" size="24" class="ma-2 cursor-pointer" @click="changeView"/>
              </div>
            </teleport>
            <div ref="icon">
              <router-link :to="{path: `/profile/${tapStore?.currentTap?.alias}/${tapStore.view ? 'view' : 'edit'}/${tapStore?.currentTapLang?.lang.toLowerCase()}`, query: $route.query}">
                <v-icon :icon="tapStore.view ? EyesHideIcon : EyesIcon" v-bind="mergeProps(tooltip, hover)" :color="isHovering ? 'primary' : 'BW-500'" size="24" class="ma-2 cursor-pointer" @click="changeView"/>
              </router-link>
              <v-menu
                  :model-value="showOnboarding"
                  location="top start"
                  activator="parent"
                  z-index="2222"
                  :offset="[4, 6]"
                  :close-on-content-click="false"
                  transition="fade-transition"
                  @update:model-value="sentHint"
              >
                <div class="onboarding">
                  {{$t('Нажмите здесь, чтобы включить режим просмотра')}}
                  <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="sentHint">
                    {{ $t('Понятно') }}
                  </v-btn>
                </div>
                <div class="d-flex justify-start">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="10" viewBox="0 0 40 10" fill="none" class="onboarding-arrow">
                    <path d="M19.9508 0L16.9419 2.99887C12.4434 7.48242 6.35102 10 -0.000296474 10L39.9019 10C33.5506 10 27.4583 7.48242 22.9597 2.99887L19.9508 0Z" fill="white"/>
                  </svg>
                </div>
              </v-menu>
            </div>
          </template>
        </v-hover>
      </template>
    </v-tooltip>

    <div class="flex-1-1 position-relative">
      <v-fade-transition leave-absolute>
        <v-btn variant="flat" color="primary" rounded="lg" class="big-btn w-100" v-if="tapStore.currentTap?.imageLoading">
          <template v-slot:prepend>
            <v-progress-circular size="24" :width="2" indeterminate color="white" bg-color="transparent"/>
          </template>
          {{$t('Загружается изображение')}}...
        </v-btn>
        <v-btn variant="flat" color="primary" rounded="lg" class="big-btn w-100" v-else-if="state == 'loading'">
          <template v-slot:prepend>
            <v-progress-circular size="24" :width="2" indeterminate color="white" bg-color="transparent"/>
          </template>
          {{$t('Идёт публикация…')}}
        </v-btn>

        <v-btn variant="flat" color="success" rounded="lg" class="big-btn w-100" v-else-if="state == 'published' || state == 'change-published'">
          <template v-slot:prepend>
            <v-icon :icon="CheckIcon" size="20"/>
          </template>
          <template v-if="state == 'published'">
            {{$t('Страница опубликована')}}
          </template>
          <template v-else>
            {{$t('Изменения опубликованы')}}
          </template>
        </v-btn>
        <v-btn-group v-else variant="flat" rounded="lg" class="w-100" ref="btnGroupRef"
                     :color="tapStore?.currentTap?.status.id == 3 && !tapStore?.currentTapLang?.changed && !tapStore.currentTapLang?.infoChanged ? 'BW-200' : 'primary'">
          <v-menu v-model="showMenu" :target="btnGroupRef" :width="btnGroupRef?.$el.offsetWidth" class="menu-publish">
            <div class="info">
              <div class="element" @click="unPublishPage">
                <div class="main-text">{{$t('Снять с публикации')}}</div>
                <div>{{$t('Пока страница снята с публикации, её видите только вы')}}</div>
              </div>
            </div>
          </v-menu>
          <v-btn class="big-btn flex-1-1" @click="publishPage">
            <template v-if="tapStore?.currentTap?.status.id != 3">
              {{$t('Опубликовать страницу')}}
            </template>
            <template v-else-if="(tapStore?.currentTap?.status.id == 3 && (tapStore?.currentTapLang?.changed || tapStore.currentTapLang?.infoChanged))">
              {{$t('Опубликовать изменения')}}
            </template>
            <template v-else-if="tapStore?.currentTap?.status.id == 3 && !tapStore?.currentTapLang?.changed && !tapStore.currentTapLang?.infoChanged">
              {{$t('Страница опубликована')}}
            </template>
          </v-btn>
          <v-btn class="small-btn" size="40" @click="showMenu = true" v-if="tapStore?.currentTap?.status.id == 3">
            <template v-slot:default>
              <v-icon :icon="ArrowDropDownIcon" size="20" :class="{'rotate-180': showMenu}"
                      :color="tapStore?.currentTap?.status.id == 3 && !tapStore?.currentTapLang?.changed && !tapStore.currentTapLang?.infoChanged ? 'BW-500' : 'white'"/>
            </template>
          </v-btn>
        </v-btn-group>
      </v-fade-transition>
      <v-fade-transition>
        <div class="publish-hint" v-if="showPublishHint">
          {{ $t('Чтобы опубликовать страницу, заполните хотя бы один блок') }}
          <v-btn variant="flat" color="primary" rounded="lg" class="w-100 publish-hint__btn" @click="showPublishHint = false">
            {{ $t('Понятно') }}
          </v-btn>
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="10" viewBox="0 0 40 10" fill="none" class="publish-hint__arrow">
            <path d="M19.9515 10L22.9604 7.00113C27.459 2.51758 33.5513 -6.96944e-07 39.9026 -1.41695e-07L0.000424306 -3.63006e-06C6.35174 -3.07481e-06 12.4441 2.51757 16.9426 7.00113L19.9515 10Z" fill="#4C5257"/>
          </svg>
        </div>
      </v-fade-transition>
    </div>

    <v-hover v-if="!isEditMode">
      <template v-slot:default="{ isHovering, props }">
        <v-icon :icon="UnionIcon" v-bind="props" :color="isHovering ? 'primary' : 'BW-500'" size="24" class="ma-2 cursor-pointer" @click="openContext"/>
      </template>
    </v-hover>
  </div>


  <v-overlay
      :model-value="showOnboarding"
      :scrim="true"
      opacity="0.7"
      persistent
      style="z-index: 2000"
  />

</template>

<script setup lang="ts">
import UnionIcon from "~/assets/icons/union.vue";
import EyesIcon from "~/assets/icons/eyes.vue";
import EyesHideIcon from "~/assets/icons/eyes-hide.vue";
import ArrowDropDownIcon from "~/assets/icons/arrow-drop-down.vue";
import CheckIcon from "~/assets/icons/check.vue";
import Context from "@/components/dialogs/Context.vue";
import {useDialogStore} from "@/stores/dialogStore.js";
import {useTapStore} from "@/stores/tapStore.js";
import {useHintStore} from "@/stores/hintStore.js";
import {computed, mergeProps, nextTick, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";

const config = useRuntimeConfig()
const host = config.public.tapLink;
const dialogStore = useDialogStore()
const tapStore = useTapStore()
const hintStore = useHintStore()
const route = useRoute()
const isEditMode = computed(() => route.params.mode === 'edit')
const showMenu = ref(false)
const showPublishHint = ref(false)
const btnGroupRef = ref(null)
const state = ref('default')
const onboarding = ref(false)
const icon = ref()
const spotlightStyle = ref({})

const openContext = () => {
  const listedTap = tapStore.tapList.find(tap => tap.id === tapStore.currentTap.id)

  dialogStore.open(Context, {
    id: tapStore.currentTap.id,
    alias: tapStore.currentTap.alias,
    name: tapStore.currentTapLang.name,
    image: tapStore.currentTap.image,
    lang: tapStore.currentTapLang.lang.toLowerCase(),
    published: tapStore.currentTap.status.id == 3,
    defaultLang: tapStore.currentTap.projectVersion.defaultLang.toLowerCase(),
    searchable: tapStore.currentTap.searchable ?? tapStore.currentTap.isSearchable ?? tapStore.currentTap.is_searchable ?? listedTap?.searchable ?? true
  })
}

const publishPage = () => {
  if (!hasBlockItems.value) {
    showPublishHint.value = true
    return
  }

  if((tapStore?.currentTap?.status.id == 3 && (!tapStore?.currentTapLang?.changed && !tapStore.currentTapLang?.infoChanged)) || state.value != 'default') return
  const change = tapStore.currentTap.status.id == 3;
  state.value = 'loading'
  tapStore.resetChangeState()
  tapStore.currentTap.status.id = 3
  tapStore.publishTap(true).then(() => {
    state.value = change ? 'change-published' : 'published'
    setTimeout(() => {
      state.value = 'default'
    }, 2000)
  })
}

const snackbar = ref(false)
const unPublishPage = () => {
  tapStore.currentTap.status.id = 1
  snackbar.value = true
  tapStore.publishTap(false).then(() => {})
}
const showViewHint = ref(false);
const viewHintShowed = ref(false);
const enableViewHintShowed = ref(true);

const changeView = () => {
  if(!tapStore.view) {
    if(!viewHintShowed.value) {
      viewHintShowed.value = true
      showViewHint.value = true
      hintStore.viewHint('change_view')
    }
  } else {
    showViewHint.value = false;
  }
  tapStore.view = !tapStore.view
}

const sentHint = () => {
  onboarding.value = false
  enableViewHintShowed.value = true
  hintStore.closeHint('view_mode_enable')
}

const showOnboarding = computed(() => {
  return !!onboarding.value && hintStore.canShow('view_mode_enable')
})

const showOnboardingChange = computed(() => {
  return !!showViewHint.value && hintStore.canShow('change_view')
})

const hasBlockItems = computed(() =>
  tapStore.currentTapLang?.blocks?.some(block => block?.blockItems?.length > 0)
)

onMounted(() => {
  hintStore.checkHint('change_view').then(result => {
    viewHintShowed.value = result;
  })
  hintStore.checkHint('view_mode_enable').then(result => {
    enableViewHintShowed.value = result;
  })
})
watch(() => tapStore.currentTapLang,(newValue) => {
      if(enableViewHintShowed.value) return
      let cnt = 0;
      if(newValue?.description || newValue?.name) {
        cnt++;
      }
      if(newValue?.socials?.length > 0) {
        cnt++;
      }
      newValue?.blocks.forEach(block => {
        block.blockItems.forEach(item => {
          cnt++
        })
      })
      if(cnt >= 3) {
        enableViewHintShowed.value = true
        onboarding.value = true
        hintStore.viewHint('view_mode_enable')
      }
    },{ deep: true }
)
watch(showOnboarding, async (val) => {
  if (!val) return
  await nextTick()

  const el = icon.value
  if (!el) return

  const rect = el.getBoundingClientRect()
  const size = (rect.width > rect.height ? rect.width : rect.height)
  spotlightStyle.value = {
    position: 'fixed',
    top: `${rect.top - ((size - rect.height)/2)}px`,
    left: `${rect.left - ((size - rect.width)/2)}px`,
    width: `${size}px`,
    height: `${size}px`,
  }
})
</script>

<style scoped lang="sass">
.profile-footer
  background: #fff
  height: 60px
  border-radius: 16px 16px 0 0
  border-top: 1px solid #F6F6F6
  border-left: 1px solid #F6F6F6
  border-bottom: 1px solid #F6F6F6
  position: sticky
  bottom: 0
  z-index: 100
  .big-btn
    --v-btn-size: 13px
  .rotate-180
    transform: rotate(180deg)
.info
  border-radius: 8px
  border: 1px solid #CED4DA
  background: #FFF
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12)
  padding: 4px 0
  margin-bottom: 2px
  .element
    padding: 10px 16px
    gap: 8px
    display: flex
    flex-direction: column
    font-size: 14px
    font-style: normal
    font-weight: 400
    color: #8D959D
    line-height: normal
    .main-text
      color: #363636
      line-height: 20px
    &:hover
      background: #F6F7F8
      cursor: pointer

.publish-hint
  position: absolute
  left: 0
  right: 0
  bottom: calc(100% + 14px)
  z-index: 10
  display: flex
  flex-direction: column
  align-items: flex-start
  align-self: stretch
  gap: 16px
  padding: 20px
  border-radius: 10px
  background: #4C5257
  box-sizing: border-box
  color: #FFF
  font-size: 16px
  font-weight: 400
  line-height: 130%
  &__btn
    align-self: stretch
    width: 100%
    height: 32px
    min-height: 32px
    font-size: 14px
  &__arrow
    position: absolute
    left: calc(50% - 20px)
    bottom: -10px

.onboarding
  padding: 20px
  background: #fff
  display: flex
  justify-content: center
  flex-direction: column
  gap: 16px
  border-radius: 10px
  color: #363636
  text-align: center
  font-size: 16px
  font-weight: 400
  line-height: 130%
  max-width: 312px
  &-arrow
    transform: rotate(180deg)
    margin-left: 6px

.spotlight
  z-index: 3000
  background-color: white !important
  border-radius: 100%
  display: flex
  align-items: center
  justify-content: center
</style>
